import {
  MdOutlinePeopleAlt,
  MdOutlineWorkHistory,
  MdOutlineVerifiedUser,
  MdOutlineFlashOn,
} from 'react-icons/md'

const Hero = () => {
  return (
    <section className='hero' id='hero'>
      <h2>Co nabízíme</h2>
      <h3>Kvalita ověřená praxí</h3>
      <div className='hero-box'>
        <div className='hero-item hero-item-l'>
          <MdOutlinePeopleAlt className='hero-item-icon' />
          <div className='hero-item-title'>Rodinná firma</div>
          <div className='hero-item-info hero-item-info-l'>
            Jsme rodinná firma specializující se na výrobu přesných strojních
            dílů a komponent.
          </div>
        </div>
        <div className='hero-item hero-item-r'>
          <MdOutlineWorkHistory className='hero-item-icon' />
          <div className='hero-item-title'>Zkušenosti</div>
          <div className='hero-item-info hero-item-info-r'>
            Dlouholetá praxe v oboru nám pomáhá úspěšně realizovat i náročná
            technická zadání.
          </div>
        </div>
        <div className='hero-item hero-item-l'>
          <MdOutlineVerifiedUser className='hero-item-icon' />
          <div className='hero-item-title hero-item-title-l'>
            Kvalita & termíny
          </div>
          <div className='hero-item-info hero-item-info-l'>
            Hlídáme každý detail výroby, abychom zaručili stoprocentní kvalitu a
            včasné dodání.
          </div>
        </div>
        <div className='hero-item hero-item-r'>
          <MdOutlineFlashOn className='hero-item-icon' />
          <div className='hero-item-title hero-item-title-r'>
            Flexibilita zakázek
          </div>
          <div className='hero-item-info hero-item-info-r'>
            Přizpůsobíme výrobu vašim potřebám, od menších sérií po rozsáhlé
            projekty.
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
